import { Link } from "react-router-dom";
import { heroData } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${heroData.bgImage})` }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-4 drop-shadow-lg">
          {heroData.title}
        </h1>
        <p className="text-lg md:text-2xl text-white/90 mb-3 font-medium">
          {heroData.subtitle}
        </p>
        <p className="text-sm md:text-base text-white/70 max-w-2xl mb-8 leading-relaxed">
          {heroData.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to={heroData.ctaLink}
            className="whitespace-nowrap px-8 py-3 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-all duration-200 cursor-pointer no-underline shadow-lg shadow-primary-500/30"
          >
            <i className="ri-play-circle-line mr-2"></i>
            {heroData.ctaText}
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap px-8 py-3 rounded-full bg-white/15 text-white font-medium text-base hover:bg-white/25 transition-all duration-200 cursor-pointer no-underline backdrop-blur-sm border border-white/20"
          >
            了解更多
          </Link>
        </div>

        <div className="absolute bottom-8 left-0 right-0 flex justify-center">
          <div className="animate-bounce w-8 h-8 flex items-center justify-center text-white/60">
            <i className="ri-arrow-down-s-line text-2xl"></i>
          </div>
        </div>
      </div>
    </section>
  );
}